<template>
    <svg fill="#000000" width="25px" height="25px" viewBox="0 0 256 256" id="Flat" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M140,80a12.00028,12.00028,0,0,1,12-12h92a12,12,0,0,1,0,24H152A12.00028,12.00028,0,0,1,140,80Zm104,36H152a12,12,0,0,0,0,24h92a12,12,0,0,0,0-24Zm0,48H176a12,12,0,0,0,0,24h68a12,12,0,0,0,0-24Zm-90.395,25.00879a11.99988,11.99988,0,1,1-23.24219,5.98242,52.021,52.021,0,0,0-100.72558,0A11.99988,11.99988,0,0,1,6.395,189.00879a75.86592,75.86592,0,0,1,37.32275-47.80811,52,52,0,1,1,72.56446,0A75.86592,75.86592,0,0,1,153.605,189.00879ZM80,132a28,28,0,1,0-28-28A28.03146,28.03146,0,0,0,80,132Z"
        />
    </svg>
</template>
<script>
export default {
    name: "IconUserList",
};
</script>
